import { StateCreator } from 'zustand';

export interface AuthSlice {
  accessToken?: string;
  setAccessToken: (token: string) => void;
  clearAccessToken: () => void;
  isRefreshingToken: boolean;
  setIsRefreshingToken: (v: boolean) => void;
}

export const createAuthSlice: StateCreator<AuthSlice> = (set) => ({
  accessToken: undefined,
  setAccessToken: (accessToken: string) => set({ accessToken }),
  clearAccessToken: () => set(({ accessToken, ...rest }) => rest, true),
  isRefreshingToken: false,
  setIsRefreshingToken: (v: boolean) => set({ isRefreshingToken: v }),
});
